import Vue from 'vue';
import Vuex from 'vuex';
import { defaultChecked, defaultSliderValue, defaultCheckedImage } from './default_values';

// install vuex
Vue.use(Vuex);

// アプリケーションが起動した時のステート（初期状態）を保持するためのオブジェクトを作ります。
const state = {
	query: {
		w: '',
		c: ''
	},
	checked: defaultChecked(),
	checkedImage: defaultCheckedImage(),
	sliderValue: defaultSliderValue(),
	scstr: '',
	areaCode: '',
	prefecturesList: [
		'北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県', '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県', '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県', '鳥取県', '島根県', '岡山県', '広島県', '山口県', '徳島県', '香川県', '愛媛県', '高知県', '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県'
	],
	district: [
		{id: 'sat1', name: '千代田区'},
		{id: 'sat2', name: '中央区'},
		{id: 'sat3', name: '港区'},
		{id: 'sat4', name: '新宿区'},
		{id: 'sat5', name: '文京区'},
		{id: 'sat6', name: '台東区'},
		{id: 'sat7', name: '墨田区'},
		{id: 'sat8', name: '江東区'},
		{id: 'sat9', name: '品川区'},
		{id: 'sat10', name: '目黒区'},
		{id: 'sat11', name: '大田区'},
		{id: 'sat12', name: '世田谷区'},
		{id: 'sat13', name: '渋谷区'},
		{id: 'sat14', name: '中野区'},
		{id: 'sat15', name: '杉並区'},
		{id: 'sat16', name: '豊島区'},
		{id: 'sat17', name: '北区'},
		{id: 'sat18', name: '荒川区'},
		{id: 'sat19', name: '板橋区'},
		{id: 'sat20', name: '練馬区'},
		{id: 'sat21', name: '足立区'},
		{id: 'sat22', name: '葛飾区'},
		{id: 'sat23', name: '江戸川区'},
		{id: 'sato', name: '23区外'}
	],
	prefectures: [
		{id: 'sa1', name: '北海道'},
		{id: 'sa2', name: '青森県'},
		{id: 'sa3', name: '岩手県'},
		{id: 'sa4', name: '宮城県'},
		{id: 'sa5', name: '秋田県'},
		{id: 'sa6', name: '山形県'},
		{id: 'sa7', name: '福島県'},
		{id: 'sa8', name: '茨城県'},
		{id: 'sa9', name: '栃木県'},
		{id: 'sa10', name: '群馬県'},
		{id: 'sa11', name: '埼玉県'},
		{id: 'sa12', name: '千葉県'},
		{id: 'sa13', name: '東京都'},
		{id: 'sa14', name: '神奈川県'},
		{id: 'sa15', name: '新潟県'},
		{id: 'sa16', name: '富山県'},
		{id: 'sa17', name: '石川県'},
		{id: 'sa18', name: '福井県'},
		{id: 'sa19', name: '山梨県'},
		{id: 'sa20', name: '長野県'},
		{id: 'sa21', name: '岐阜県'},
		{id: 'sa22', name: '静岡県'},
		{id: 'sa23', name: '愛知県'},
		{id: 'sa24', name: '三重県'},
		{id: 'sa25', name: '滋賀県'},
		{id: 'sa26', name: '京都府'},
		{id: 'sa27', name: '大阪府'},
		{id: 'sa28', name: '兵庫県'},
		{id: 'sa29', name: '奈良県'},
		{id: 'sa30', name: '和歌山県'},
		{id: 'sa31', name: '鳥取県'},
		{id: 'sa32', name: '島根県'},
		{id: 'sa33', name: '岡山県'},
		{id: 'sa34', name: '広島県'},
		{id: 'sa35', name: '山口県'},
		{id: 'sa36', name: '徳島県'},
		{id: 'sa37', name: '香川県'},
		{id: 'sa38', name: '愛媛県'},
		{id: 'sa39', name: '高知県'},
		{id: 'sa40', name: '福岡県'},
		{id: 'sa41', name: '佐賀県'},
		{id: 'sa42', name: '長崎県'},
		{id: 'sa43', name: '熊本県'},
		{id: 'sa44', name: '大分県'},
		{id: 'sa45', name: '宮崎県'},
		{id: 'sa46', name: '鹿児島県'},
		{id: 'sa47', name: '沖縄県'},
		{id: 'ovs', name: '海外'}
	],
	situation: [
		{id: 'sha1', name: '自然光', iconclass: 'icon_natural_light', icontitle: '自然光'},
		{id: 'sha2', name: '洋風（建物）', iconclass: 'icon_eu_style_belong', icontitle: '洋風'},
		{id: 'sha3', name: '和風（建物）', iconclass: 'icon_jp_style_belong', icontitle: '和風'},
		{id: 'sha4', name: '和室', iconclass: 'icon_jp_style_room', icontitle: '和室'},
		{id: 'sha5', name: 'バスルーム', iconclass: 'icon_bathroom', icontitle: 'バスルーム'},
		{id: 'sha6', name: 'テラス・デッキ', iconclass: 'icon_terrace', icontitle: 'テラス・デッキ'},
		{id: 'sha7', name: 'リビング', iconclass: 'icon_living', icontitle: 'リビング'},
		{id: 'sha8', name: 'オフィス', iconclass: 'icon_office', icontitle: 'オフィス'},
		{id: 'sha9', name: 'レストラン・カフェ', iconclass: 'icon_restaurant', icontitle: 'レストラン・カフェ'},
		// {id: 'sha10', name: '病院', iconclass: 'icon_hospital', icontitle: '病院'},
		{id: 'sha11', name: '屋上', iconclass: 'icon_housetop', icontitle: '屋上'},
		{id: 'sha12', name: '多目的スペース', iconclass: 'icon_multi_space', icontitle: '多目的スペース'},
		{id: 'sha13', name: '木床・タイル床', iconclass: 'icon_floor', icontitle: '木床・タイル床'},
		{id: 'sha14', name: '庭（和風）', iconclass: 'icon_garden', icontitle: '庭'},
		{id: 'sha15', name: '庭（洋風）', iconclass: 'icon_garden', icontitle: '庭'},
		{id: 'sha16', name: '家具常備', iconclass: 'icon_furniture', icontitle: '家具レンタル'},
		{id: 'sha17', name: 'その他のタイプ', iconclass: '', icontitle: ''}
		// {id: 'sha18', name: 'その他シチュエーション', iconclass: '', icontitle: ''}
	],
	facility: [
		{id: 'shb19', name: 'キッチン', iconclass: 'icon_kitchen', icontitle: 'キッチン'},
		// {id: 'shb20', name: 'アールホリゾント', iconclass: 'icon_rhorizont_white', icontitle: 'アールホリゾント'},
		{id: 'shb21', name: '俯瞰撮影', iconclass: 'icon_down_shot', icontitle: '俯瞰撮影'},
		// {id: 'shb22', name: 'ムービー', iconclass: 'icon_vtr', icontitle: 'ムービー'},
		{id: 'shb23', name: '同時録音', iconclass: 'icon_synchronous_recording', icontitle: '同時録音可'},
		{id: 'shb24', name: '水使用可（ホリゾント内）', iconclass: 'icon_water', icontitle: '水使用可（ホリゾント内）'},
		{id: 'shb25', name: 'Wi-Fi', iconclass: 'icon_communication_environment', icontitle: 'Wi-Fi'},
		{id: 'shb26', name: 'メイクルーム', iconclass: 'icon_makeup_room', icontitle: 'メイクルーム'},
		{id: 'shb27', name: '車直接搬入', iconclass: 'icon_direct_carrying', icontitle: '車直接搬入'},
		{id: 'shb28', name: 'シャワールーム', iconclass: 'icon_shower_room', icontitle: 'シャワールーム'},
		{id: 'shb29', name: 'ストックルーム・倉庫', iconclass: 'icon_stock_room', icontitle: 'ストックルーム・倉庫'},
		{id: 'shb30', name: '大型エレベーター', iconclass: 'icon_elevator', icontitle: '大型エレベーター'}
		// {id: 'shb31', name: 'その他設備・備品', iconclass: '', icontitle: ''}
	],
	service: [
		{id: 'shc32', name: 'ストロボレンタル', iconclass: 'icon_flash_rental', icontitle: 'ストロボレンタル'},
		{id: 'shc33', name: 'HMIレンタル', iconclass: 'icon_hmi_rental', icontitle: 'HMIレンタル'},
		{id: 'shc34', name: '機材レンタル', iconclass: 'icon_machine_rental', icontitle: '機材レンタル'},
		{id: 'shc35', name: 'アシスタントサービス', iconclass: 'icon_assistant_service', icontitle: 'アシスタントサービス'}
		// {id: 'shc36', name: 'その他サービス', iconclass: '', icontitle: ''}
	],
	sliderValueBtn: {
		area: [
			{id: 'ssmBtn_lt50', value: '0;50', label: '50㎡未満'},
			{id: 'ssmBtn_gte50', value: '50;300', label: '50㎡以上'},
			{id: 'ssmBtn_gte100', value: '100;300', label: '100㎡以上'},
			{id: 'ssmBtn_gte150', value: '150;300', label: '150㎡以上'},
			{id: 'ssmBtn_gte250', value: '250;300', label: '250㎡以上'},
			{id: 'ssmBtn_all', value: '0;300', label: '指定なし'}
		],
		height: [
			// {id: 'sshBtn_lt4', value: '0;4', label: '4m未満'},
			{id: 'sshBtn_gte4', value: '4;10', label: '4m以上'},
			{id: 'sshBtn_gte6', value: '6;10', label: '6m以上'},
			{id: 'sshBtn_gte8', value: '8;10', label: '8m以上'},
			{id: 'sshBtn_all', value: '0;10', label: '指定なし'}
		],
		price: [
			{id: 'spBtn_lt10000', value: '0;10000', label: '10,000円以下'},
			{id: 'spBtn_lt15000', value: '0;15000', label: '15,000円以下'},
			{id: 'spBtn_lt20000', value: '0;20000', label: '20,000円以下'},
			{id: 'spBtn_lt25000', value: '0;25000', label: '25,000円以下'},
			{id: 'spBtn_lt50000', value: '0;50000', label: '指定なし'}
		]
	},
	image: [
		{id: 'imst', name: 'スタイリッシュ', btnimage: 'stylish.svg', btnonimage: 'stylish_on.svg'},
		{id: 'imrt', name: 'レトロ', btnimage: 'retro.svg', btnonimage: 'retro_on.svg'},
		{id: 'imna', name: 'ナチュラル', btnimage: 'natural.svg', btnonimage: 'natural_on.svg'},
		{id: 'imsi', name: 'シンプル', btnimage: 'simple.svg', btnonimage: 'simple_on.svg'},
		{id: 'imel', name: 'エレガント', btnimage: 'elegant.svg', btnonimage: 'elegant_on.svg'},
		{id: 'imwh', name: 'ホワイト', btnimage: 'white.svg', btnonimage: 'white_on.svg'},
		{id: 'imrz', name: 'リゾート', btnimage: 'resort.svg', btnonimage: 'resort_on.svg'},
		{id: 'imja', name: '和', btnimage: 'japanese.svg', btnonimage: 'japanese_on.svg'},
		{id: 'imam', name: 'アメリカン', btnimage: 'american.svg', btnonimage: 'american_on.svg'},
		{id: 'imeu', name: 'ヨーロピアン', btnimage: 'european.svg', btnonimage: 'european_on.svg'}
	]
};
// 様々なミューテーションのためのオブジェクトを作ります。ミューテーションは後で書きます。
const mutations = {
	SEARCH_WORDS (state, value) {
		state.query.w = value;
	},
	SEARCH_CONDITIONS (state, value) {
		state.query.c = value;
	},
	RADIO (state, name, value) {
		state.checked[name] = value;
	},
	CHECKBOX (state, name, value) {
		state.checked[name] = value;
	},
	AREA_CODE (state, value) {
		state.areaCode = value;
	},
	SC_STR (state, value) {
		state.scstr = value;
	},
	IMAGE_SEARCH (state, name, value){
		state.checkedImage[name] = value;
	},
	RESET (state) {
		state.query.w = '';
		state.query.c = '';
		state.checked = defaultChecked();
		state.checkedImage = defaultCheckedImage();
		state.sliderValue = defaultSliderValue();
	},
	RESET_CHECKED_IMAGE (state) {
		state.checkedImage = defaultCheckedImage();
	}
};

// 初期状態とミューテーションを結合し、Vuex のストアを作成します。このストアは私達のアプリケーションへつなげることができます。
export default new Vuex.Store({
	state,
	mutations
});



// WEBPACK FOOTER //
// ./src/vuex/store.js